module.exports = __webpack_public_path__ + "static/media/wessling-login-small-bg.ccd900dd.jpg";